import Axios from "axios";
import Store from '@/store';

export default {
	exchangeDevTestLogin(ticket) {
		return Axios.post(
			`${process.env.VUE_APP_DOMAIN}/DevTestLogin/exchange.html`,
			`ticket=${encodeURIComponent(ticket)}`,
			{headers: {'Content-Type': 'application/x-www-form-urlencoded'}}
		);
	},

	getSelectedUserinfoId(userinfo_id = null) {
		return userinfo_id || Store.state.selectedUserinfoId || null;
	},

	ensureSelectedUserinfoId(userinfo_id = null) {
		let selectedUserinfoId = this.getSelectedUserinfoId(userinfo_id);
		if (selectedUserinfoId || !Store.state.reqParams) {
			return Promise.resolve(selectedUserinfoId);
		}
		return this.orderAddress().then(res => {
			if (res && res.first_user_info_id) {
				Store.commit('setSelectedUserinfoId', res.first_user_info_id);
				return res.first_user_info_id;
			}
			return null;
		}).catch(err => null);
	},

	checkRegister() {
		return Axios.get(`${process.env.VUE_APP_DOMAIN}/User/checkRegister.html`, {
			params: {
				...Store.state.reqParams
			}
		});
	},

	initWxMini(
		code
	) {
		return Axios.get(`${process.env.VUE_APP_DOMAIN}/Weixin/miniLogin`, {
			params: {
				code
			}
		});
	},

	getWxParams() {
		return Axios.get(`${process.env.VUE_APP_DOMAIN}/Api/getJsApiParam`, {
			params: {
				url: window.location.href
			}
		});
	},

	getReqParams(
		code
	) {
		return Axios.get(`${process.env.VUE_APP_DOMAIN}/Weixin/getAccessToken`, {
			params: {
				code
			}
		});
	},

	allInfo(force = false, checkout = false, userinfo_id = null) {
		return this.ensureSelectedUserinfoId(userinfo_id).then(selectedUserinfoId => {
			let cacheUserinfoId = Store.state.allInfo ? Store.state.allInfo.__userinfo_id : null;
			if (Store.state.allInfo && !force && String(cacheUserinfoId || '') === String(selectedUserinfoId || '')) {
				return JSON.parse(JSON.stringify(Store.state.allInfo));
			}
			return Axios.get(`${process.env.VUE_APP_DOMAIN}/Community/shop`, {
				params: {
					community_id: 2968,
					open_level: 1,
					checkout: checkout ? 1 : 0,
					userinfo_id: selectedUserinfoId,
					...Store.state.reqParams
				}
			}).then(res => {
				let allInfo = JSON.parse(JSON.stringify(res));
				allInfo.__userinfo_id = selectedUserinfoId || null;
				Store.commit('setAllInfo', allInfo);
				Store.commit('setCartTotalPrice', getCartPayTotalPrice(allInfo.cart));
				return JSON.parse(JSON.stringify(allInfo));
			}).catch(err => {});
		});
	},

	addCart(
		merchantid,
		goods_id
	) {
		let userinfo_id = this.getSelectedUserinfoId();
		return Axios.get(`${process.env.VUE_APP_DOMAIN}/User/addToCart`, {
			params: {
				merchantid,
				goods_id,
				userinfo_id,
				...Store.state.reqParams
			}
		});
	},

	removeCart(
		merchantid,
		goods_id
	) {
		return Axios.get(`${process.env.VUE_APP_DOMAIN}/User/removeToCart`, {
			params: {
				merchantid,
				goods_id,
				...Store.state.reqParams
			}
		});
	},

	addressList() {
		return Axios.get(`${process.env.VUE_APP_DOMAIN}/User/userInfoList`, {
			params: {
				show_all: 1,
				community_id: 2968,
				...Store.state.reqParams
			}
		});
	},

	sendCode(
		phone_num
	) {
		return Axios.get(`${process.env.VUE_APP_DOMAIN}/User/sendVerifyCode`, {
			params: {
				phone_num,
				...Store.state.reqParams
			}
		});
	},

	addAddress(
		realname,
		gender,
		phone_num,
		verify_code,
		street_address
	) {
		return Axios.get(`${process.env.VUE_APP_DOMAIN}/User/addUserInfo`, {
			params: {
				'userinfo[realname]': realname,
				'userinfo[gender]': gender,
				'userinfo[phone_num]': phone_num,
				'userinfo[verify_code]': verify_code,
				'userinfo[street_address]': street_address,
				'userinfo[community_id]': 2968,
				...Store.state.reqParams
			}
		});
	},

	search(
		keyword,
		qrcode,
		merchantid
	) {
		let userinfo_id = this.getSelectedUserinfoId();
		return Axios.get(`${process.env.VUE_APP_DOMAIN}/Community/searchGoods`, {
			params: {
				keyword,
				qrcode,
				merchantid,
				userinfo_id,
				...Store.state.reqParams
			}
		});
	},

	orderAddress() {
		return Axios.get(`${process.env.VUE_APP_DOMAIN}/User/countUserInfoList`, {
			params: {
				community_id: 2968,
				show_all: 0,
				add_extend_order_id: Store.state.addExtendOrderId,
				...Store.state.reqParams
			}
		});
	},

	userInfo(
		userinfo_id,
		merchantid,
		add_extend_order_id,
		is_mini
	) {
		return Axios.get(`${process.env.VUE_APP_DOMAIN}/User/getUserInfo`, {
			params: {
				userinfo_id,
				merchantid,
				add_extend_order_id,
				is_mini,
				...Store.state.reqParams
			}
		});
	},

	cartInfo(
		merchantid,
		add_extend_order_id,
		checkout = false,
		userinfo_id = null
	) {
		let selectedUserinfoId = this.getSelectedUserinfoId(userinfo_id);
		return Axios.get(`${process.env.VUE_APP_DOMAIN}/User/getCart`, {
			params: {
				merchantid,
				add_extend_order_id,
				show_present: 1,
				multi_coupon: 1,
				checkout: checkout ? 1 : 0,
				userinfo_id: selectedUserinfoId,
				...Store.state.reqParams
			}
		});
	},

	createOrder(
		merchantid,
		userinfo_id,
		pay_type,
		user_coupon_ids,
		add_extend_order_id,
		is_mini
	) {
		return Axios.get(`${process.env.VUE_APP_DOMAIN}/Order/generateOrder`, {
			params: {
				merchantid,
				userinfo_id,
				pay_type,
				user_coupon_ids,
				add_extend_order_id,
				is_mini,
				...Store.state.reqParams,
				send_time: 0,
				multi_coupon: 1
			}
		});
	},

	emptyCart(
		merchantid
	) {
		return Axios.get(`${process.env.VUE_APP_DOMAIN}/User/clearCart`, {
			params: {
				merchantid,
				...Store.state.reqParams
			}
		});
	},

	orderList(
		merchantid
	) {
		return Axios.get(`${process.env.VUE_APP_DOMAIN}/Order/orderList`, {
			params: {
				merchantid,
				...Store.state.reqParams
			}
		});
	},

	orderListInfo(
		order_id,
		merchantid
	) {
		return Axios.get(`${process.env.VUE_APP_DOMAIN}/Order/getOrder`, {
			params: {
				order_id,
				merchantid,
				...Store.state.reqParams
			}
		});
	},

	serviceUpload(
		media_id
	) {
		return Axios.get(`${process.env.VUE_APP_DOMAIN}/ShopFeedback/newUploadImg`, {
			params: {
				media_id
			}
		});
	},

	serviceAddress() {
		return Axios.get(`${process.env.VUE_APP_DOMAIN}/ShopFeedback/newShowAddressList`, {
			params: {
				...Store.state.reqParams
			}
		})
	},

	addService(
		manufacture_date,
		distribution_id,
		name,
		phone_num,
		address,
		userid,
		description,
		photo,
	) {
		return Axios.get(`${process.env.VUE_APP_DOMAIN}/ShopFeedback/newAddFeedback`, {
			params: {
				manufacture_date,
				distribution_id,
				name,
				phone_num,
				address,
				userid,
				description,
				photo,
				...Store.state.reqParams
			}
		});
	},

	serviceList() {
		return Axios.get(`${process.env.VUE_APP_DOMAIN}/ShopFeedback/newShopFeedbackList`, {
			params: {
				...Store.state.reqParams
			}
		});
	},

	indexList() {
		return Axios.get(`${process.env.VUE_APP_DOMAIN}/Index/recommentIndex`);
	},

	indexListGoods(
		recomment_cate_id
	) {
		return Axios.get(`${process.env.VUE_APP_DOMAIN}/Index/recommentIndexGoods`, {
			params: {
				recomment_cate_id
			}
		});
	},

	recommendGoods() {
		return Axios.get(`${process.env.VUE_APP_DOMAIN}/Index/recommentGoods`);
	},

	user() {
		return Axios.get(`${process.env.VUE_APP_DOMAIN}/User/userCenter`, {
			params: {
				community_id: 2968,
				open_level: 1,
				add_extend_order_id: 0,
				...Store.state.reqParams
			}
		});
	},

	userCoupons() {
		return Axios.get(`${process.env.VUE_APP_DOMAIN}/User/getUserCoupon`, {
			params: {
				...Store.state.reqParams
			}
		});
	},

	addSearchHistory(
		keywords
	) {
		return Axios.get(`${process.env.VUE_APP_DOMAIN}/UserSearch/addSearch`, {
			params: {
				keywords,
				...Store.state.reqParams
			}
		});
	},

	searchHistoryList() {
		return Axios.get(`${process.env.VUE_APP_DOMAIN}/UserSearch/searchHistoryHotGoods`, {
			params: {
				...Store.state.reqParams
			}
		});
	},

	keywordSearch(keywords) {
		return Axios.get(`${process.env.VUE_APP_DOMAIN}/Api/grouponKeyword`, {
			params: {
				keywords,
				...Store.state.reqParams
			}
		});
	},

	cartTotalPrice() {
		return Axios.get(`${process.env.VUE_APP_DOMAIN}/User/sumCartPrice`, {
			params: {
				...Store.state.reqParams,
				merchantid: 352
			}
		});
	},

	hotGoods() {
		return Axios.get(`${process.env.VUE_APP_DOMAIN}/Index/recommentGoodsIndex`);
	},

	countDown() {
		return Axios.get(`${process.env.VUE_APP_DOMAIN}/Community/getLimitDiscount`)
	},

	updateOrderAddress(
		order_id,
		userinfo_id
	) {
		return Axios.get(`${process.env.VUE_APP_DOMAIN}/Order/updateOrderUserDistribution`, {
			params: {
				order_id,
				userinfo_id,
				...Store.state.reqParams
			}
		})
	},

	// ========= 帮我找货 =========

	helpFindGoodsMyList(
		page = 1,
		page_size = 10,
		status = ''
	) {
		// status 不传则查全部
		const params = {
			page,
			page_size,
			...Store.state.reqParams
		};
		if (status !== '' && status !== null && status !== undefined) {
			params.status = status;
		}

		return Axios.get(`${process.env.VUE_APP_DOMAIN}/HelpFindGoods/myList`, {
			params
		});
	},

	helpFindGoodsDetail(
		id
	) {
		return Axios.get(`${process.env.VUE_APP_DOMAIN}/HelpFindGoods/detail`, {
			params: {
				id,
				...Store.state.reqParams
			}
		});
	},

	// 提交找货需求（multipart 上传 images_file[]）
	// 注意：Axios.post 传 FormData，不走 params
	  // 帮我找货：提交需求（images 为逗号分隔字符串 或数组都行，这里用字符串）
	  helpFindGoodsAddDemand(
	    product_name,
	    remark,
	    images // 可选：'a.jpg,b.jpg' 或 ''
	  ) {
	    const params = {
	      product_name,
	      remark,
	      ...Store.state.reqParams
	    };
	    if (images) {
	      params.images = images;
	    }
	
	    return Axios.get(`${process.env.VUE_APP_DOMAIN}/HelpFindGoods/addDemand`, {
	      params
	    });
	  },

	// 帮我找货：JSSDK 图片上传（复用服务反馈的上传接口）
	helpFindGoodsUpload(
		media_id
	) {
		return Axios.get(`${process.env.VUE_APP_DOMAIN}/ShopFeedback/newUploadImg`, {
			params: {
				media_id
			}
		});
	},

}

function getCartPayTotalPrice(cart = {}) {
	return (cart.total_price || 0) + (cart.self_goods_price || 0);
}
